import { render, staticRenderFns } from "./BusinessAddress.vue?vue&type=template&id=6089ff5f"
import script from "./BusinessAddress.vue?vue&type=script&lang=js"
export * from "./BusinessAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports